import React from 'react';

import { selectedPodProps } from 'apps/build_your_plan/store/PlanStore';
import { TranslatedMessage } from 'common/components/Intl';
import PriceSpan from 'common/components/formatters/PriceSpan';
import LineItem from 'common/components/shop/LineItem';

const PodReviewLineItem = ({ pod }) => {
  const details = (
    <>
      <TranslatedMessage
        id="cart.nicotine_strength"
        values={{ strength: pod.nicotine_strength_percent }}
      />{' '}
      -{' '}
      <TranslatedMessage
        id="cart.pod_count"
        values={{ pod_count: pod.pod_quantity }}
      />
      <br />
      <TranslatedMessage
        id="cart.price_each"
        values={{
          price: <PriceSpan cents={pod.price} />,
        }}
      />
    </>
  );

  // TODO: this should use LineItemPrice but it expects to be passed an amount
  // (Float) but the data that we're working with uses cents (Integer). We'll
  // need to address this once we start displaying discounts.
  const price = (
    <PriceSpan
      cents={pod.price * pod.quantity}
      className="line-item__price heading--small"
    />
  );

  return (
    <LineItem
      className="build-your-plan-review__item"
      details={details}
      imageUrl={pod.image_url}
      key={pod.sku}
      name={pod.name}
      price={price}
      quantity={pod.quantity}
      quantityControls={false}
    />
  );
};

PodReviewLineItem.propTypes = {
  pod: selectedPodProps,
};

export default PodReviewLineItem;
